import axios from 'axios';
import UserProfile from "components/UserProfile/UserProfile";
import { apiUrl as API_BASE_URL } from 'config';

// Create axios instance
const api = axios.create({
    baseURL: API_BASE_URL,
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${UserProfile.getToken()}` // initial token
    }
});

// Request interceptor to update token dynamically
api.interceptors.request.use(async (config) => {
    const token = await UserProfile.getToken(); // assuming async
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
}, (error) => Promise.reject(error));


export default api;